// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i6N12","top":"styles_top__PLzsZ"};